/* ++++++++++ --------------- EXPORT : DATA TOP QUESTIONS ANSWERED : STYLES --------------- ++++++++++ */
export default theme => ({
    topquestionsanswered:{

    }
})